export default "__VITE_ASSET__6eaa5cfe__"